export default __webpack_public_path__ + "static/media/forkedlightning.7756cd40.png";